
import { Stack } from 'ui/stack';

import { formatDisplayDate } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.helpers';

interface DeferredReasonBoxProps {
  note: string;
  deferredDate: string | undefined;
}

const DeferredReasonBox = ({ note, deferredDate }: DeferredReasonBoxProps) => (
  <Stack
    sx={{
      gap: 0.5,
      borderRadius: '0.375rem',
      borderWidth: '1px',
      borderColor: 'tokens.navy.200',
      bgcolor: 'tokens.gray.100',
      p: 1.5,
    }}
    data-testid="deferred-reason-box"
  >
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '0.75rem',
        lineHeight: '1rem',
        fontWeight: 500,
        color: 'tokens.gray.700',
      }}
    >
      <span>Reason</span>
      <span>Deferred {formatDisplayDate(deferredDate)}</span>
    </Stack>
    <p className="text-sm font-medium text-gray-700">{note}</p>
  </Stack>
);

export default DeferredReasonBox;
